import type { ChatMessage } from '@teo/widget-shared';
import { isTypingPlaceholderMessage } from './typing-placeholder.js';

function isInboundReplyRole(message: ChatMessage): boolean {
  return message.role === 'bot' || message.role === 'manager';
}

/**
 * True when `next` contains a bot/manager row id that was not in `previous`.
 * Used to disarm client typing — user-echo / status-only sync must not match.
 */
export function hasNewInboundReply(
  previous: ChatMessage[],
  next: ChatMessage[],
): boolean {
  const previousIds = new Set<string>();
  for (const message of previous) {
    if (
      isInboundReplyRole(message) &&
      !isTypingPlaceholderMessage(message)
    ) {
      previousIds.add(message.id);
    }
  }

  for (const message of next) {
    if (
      isInboundReplyRole(message) &&
      !isTypingPlaceholderMessage(message) &&
      !previousIds.has(message.id)
    ) {
      return true;
    }
  }

  return false;
}
